const { AllSocialMedia } = require("../features/admin/common/Slice");

exports.APIS = {
  Auth: "/common/auth/admin-login",
  UserGet: "/common/auth/user-info",
  ChangePassword: "/common/auth/change-password",

  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    Privacy_and_Policy: "/admin/masters/privacyandpolicy",
    Terms_and_Conditions: "/admin/masters/termsandconditions",
    Category: "/admin/masters/category",
    Social_Link: "/admin/masters/social-link",
    Our_Team: "/admin/masters/our-team",
    AppSetUp: "/admin/masters/app-setup",
    Faq: "/admin/masters/faq",
    StudentDocument: "/admin/masters/student-document",
  },

  Courses: {
    Program_Highlight: "/admin/college/program-highlight",
    Eligibility_Requirement: "/admin/college/eligibility-requirement",
    Career_Requirement: "/admin/college/career-documents",
    Requirement_Documents: "/admin/college/required-documents",
    University: "/admin/college/university",
    Course: "/admin/college/course",
    Accomodation: "/admin/college/accomodation",
    Study_Program: "/admin/college/study-program",
  },

  Internship: {
    Document: "/admin/hotel/documents",
    Requirement: "/admin/hotel/requirement",
    Internship: "/admin/hotel/internship",
    Registration1: "/admin/hotel/auth/registration1",
    Registration2: "/admin/hotel/auth/registration2",
    Registration3: "/admin/hotel/auth/registration3",
    Registration4: "/admin/hotel/auth/registration4",
    Registration5: "/admin/hotel/auth/registration5",
    GetRegistration1: "/admin/hotel/auth/get-registration1",
    GetRegistration2: "/admin/hotel/auth/get-registration2",
    GetRegistration3: "/admin/hotel/auth/get-registration3",
    GetRegistration4: "/admin/hotel/auth/get-registration4",
    GetRegistration5: "/admin/hotel/auth/get-registration5",
  },

  Student: {
    StudentApplication: "/admin/student/college",
    HotelApplication: "/admin/student/hotel",
    Ticket: "/admin/student/ticket-raised",
    add_document: "/admin/student/add-student-document",
    Registration1: "/admin/student/auth/registration1",
    GetRegistration1: "/admin/student/auth/get-registration1",
    Registration2: "/admin/student/auth/registration2",
    GetRegistration2: "/admin/student/auth/get-registration2",
    Registration3: "/admin/student/auth/registration3",
    GetRegistration3: "/admin/student/auth/get-registration3",
    Registration4: "/admin/student/auth/registration4",
    GetRegistration4: "/admin/student/auth/get-registration4",
    Registration5: "/admin/student/auth/registration5",
    GetRegistration5: "/admin/student/auth/get-registration5",
  },

  College: {
    Registration1: "/admin/college/registration/registration1",

    GetRegistration1: "/admin/college/registration/get-registration1",

    Registration2: "/admin/college/registration/registration2",

    Registration3: "/admin/college/registration/registration3",

    Registration4: "/admin/college/registration/registration4",

    Registration5: "/admin/college/registration/registration5",
  },

  Autho: {
    Registration: "/admin/auth/registration",
    GETUser: "/admin/auth/get-user",
    Update_User: "/admin/auth/profileedit",
  },

  TicketRaise: {
    Tickets: "/admin/ticket-raised",
  },

  Content: {
    Testimonial: "/admin/content/testimonials",
    Trust_And_Safety: "/admin/content/trust-and-safety",
    Faq: "/admin/content/faq",
    Help_Category: "/admin/content/help-category",
    Help_Question: "/admin/content/help-question",
    Article: "/admin/content/article",
    Article_Comment: "/admin/content/article-comment",
  },
  Volunteer: {
    Volunteer_Mode: "/admin/volunteer/volunteer-mode",
    Volunteer_Detail: "/admin/volunteer/volunteer",
  },
  Gallery: {
    Gallery_Category: "/admin/gallery/gallery-category",
    Gallery_Images: "/admin/gallery/gallery-image",
  },
  ContactUs: {
    Contact_Us: "/admin/contact-us/contact",
  },
  FundRaise: {
    Fund_Raise: "/admin/compaign/fund-raise",
  },
  // common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",
    AllSocialLink: "/common/masters/all-social-link",
    AllHelpCategory: "/common/masters/all-help-category",
    AllGalleryCategory: "/common/masters/all-gallery-category",
    AllCategory: "/common/masters/all-category",
    AppSetup: "/common/masters/appsetup",
    AllPermmission: "/common/masters/all-permission",
    AllUniversity: "/common/masters/all-university",
    allCourse: "/common/masters/all-course",
    allProgramHighlight: "/common/masters/all-program-highlight",
    allEligibilityReqirement: "/common/masters/all-eligibility-requirement",
    allCareerRequirement: "/common/masters/all-career-requirement",
    allRequiredDocument: "/common/masters/all-required-documents",
    allAccomodation: "/common/masters/all-accomodation",
    allDocument: "/common/masters/all-document",
    allRequirement: "/common/masters/all-requirement",
    allAcceptRejectStatus: "/common/masters/all-accept_reject_statuses",
    allFaq: "/common/masters/all-faq",
    allTicketStatus: "/common/masters/all-ticket_statuses",
    all_student_document: "/common/masters/all-student-documents",
    AllGender: "/common/masters/all-gender",
    AllCollegeType: "/common/masters/all-college-type",
  },

  // Dashboard
  Dashboard: {
    dashboard: "/admin/dashboard",
  },

  UserManagement: {
    Roles: "/admin/employee-management/role",
    Student: "/admin/employee-management/student",
    College: "/admin/employee-management/college",
    Hotel: "/admin/employee-management/hotel",
    // Builder: "/admin/employee-management/builder",
    // Users: "/admin/employee-management/user",
    // Sales: "/admin/employee-management/sales",
  },

  //---------------------------------------------------------------- Website ----------------------------------------------------------

  Website: {
    Home_WhychooseUs: "/website/home/why-choose-us",
    AboutUs_WhoweAre: "/website/about-us/who-we-are",
    Home_SuccessSpeaks: "/website/home/success-speaks",
    Home_FAQ: "/website/home/home-faq",

    // Aboutus

    Aboutus_OurStory: "/website/about-us/ourstory",

    // Contact Us

    ContactUs_GetinTouch: "/website/contact-us/get-in-touch",
  },

  AdminContactUs: {
    contact_us: "/admin/contact-us",
  },

  AdminNeedAdvice: {
    need_advice: "/admin/need-advice",
  },

  Common: {
    send_otp_email: "/common/otp/otp-send-email",
    verify_otp_email: "/common/otp/verify-otp-email",
    forget_password: "/common/auth/forgot-password",
  },
};
